import axios from 'axios';
import Vue from 'vue';

export const state = {
    pricelist: [],
    pricePackages: []
};

export const mutations = {
    SET_PRICELIST(state, pricelist) {
        state.pricelist = pricelist;
    },
    SET_PRICE_PACKAGES (state, pricePackages) {
        state.pricePackages = pricePackages;
    },
    SET_PRICING_ITEM (state, { type, item}) {
        state[type].push(item);
    },
    UPDATE_PRICE_ITEM (state, { updatedPackage, type }) {
        const index = state[type].findIndex(item => item._id === updatedPackage._id);
        Vue.set(state[type], index, updatedPackage);
    },
    DELETE_PRICE_ITEM (state, { type, packageId}) {
        const index = state[type].findIndex(item => item._id === packageId);
        state[type].splice(index, 1);
    },
    CLEAR (state) {
        state.pricelist = [];
        state.pricePackages = [];
    }
};

export const getters = {
    hasPricing (state) {
        return Object.keys(state.pricelist).length > 0 && Object.keys(state.pricePackages).length > 0;
    }
};

export const actions = {
    async getPricePackages({ commit }) {
        commit('loader/START_LOADING', null, { root: true });
        try{
            const { data } = await axios.get('/price-package');
            const pricelist = data.filter(price => price.price_package_items.length === 1 && price.price_package_items[0].quantity === 1);
            const pricePackages = data.filter(price => price.price_package_items.length > 1 ||
                (price.price_package_items.length === 1 && price.price_package_items[0].quantity > 1));
            commit('SET_PRICELIST', pricelist);
            commit('SET_PRICE_PACKAGES', pricePackages);
        } finally {
            commit('loader/END_LOADING', null, { root: true });
        }
    },
    async createPriceItem({ commit }, {payload, type}) {
        commit('loader/START_LOADING', null, { root: true });
        try{
            const { data } = await axios.post(`/price-package`, payload);
            commit('SET_PRICING_ITEM', { item: data, type });
        } finally {
            commit('loader/END_LOADING', null, { root: true });
        }
    },
    async updatePriceItem({ commit }, { packageId, payload, type }) {
        commit('loader/START_LOADING', null, { root: true });
        try{
            const { data } = await axios.put(`/price-package/${packageId}`, payload);
            commit('UPDATE_PRICE_ITEM', { updatedPackage: data, type});
        } finally {
            commit('loader/END_LOADING', null, { root: true });
        }
    },
    async deletePricePackage ({ commit }, { packageId, type }) {
        commit('loader/START_LOADING', null, { root: true });
        try{
            const { data } = await axios.delete(`/price-package/${packageId}`);
            commit('DELETE_PRICE_ITEM', { packageId, type});
        } finally {
            commit('loader/END_LOADING', null, { root: true });
        }
    },
};
